module.exports = __webpack_public_path__ + "img/venmobutton2.044aadac.png";